export const TEXT  = 1;
export const IMAGE = 2;
export const VIDEO = 3;
export const AUDIO = 4;